module.exports = __webpack_public_path__ + "img/affiliate-3.14df546.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/affiliate-3.png
// module id = 1616
// module chunks = 1